export const ODDS_FORMAT = {
  AMERICAN: 'american',
  DECIMAL: 'decimal',
  FRACTIONAL: 'fractional',
  TRADITIONAL: 'traditional',
} as const;

export type OddsFormat = (typeof ODDS_FORMAT)[keyof typeof ODDS_FORMAT];
